import { useAutocomplete } from 'admin';
import { useState } from 'react';
import { Autocomplete } from 'ui';

type DealChoice = {
  id: number;
  name: string;
};
export const DealAutocomplete = ({
  required,
  onSelectDeal,
  defaultValue,
}: {
  required?: boolean;
  onSelectDeal: (deal: DealChoice | null) => void;
  defaultValue?: number;
}) => {
  const [value, setValue] = useState<DealChoice | null>(
    defaultValue ? { id: defaultValue, name: `Deal #${defaultValue}` } : null
  );

  const { autocompleteProps } = useAutocomplete<DealChoice>({
    onSearch: (value) => [
      {
        field: 'search',
        operator: 'contains',
        value,
      },
    ],
    resource: '/deals/v1/deal-choices',
  });

  return (
    <Autocomplete
      {...autocompleteProps}
      value={value}
      required={required}
      getOptionLabel={(item) => item.name}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      placeholder="Select a deal"
      onChange={(_event, newValue) => {
        setValue(newValue);
        onSelectDeal(newValue);
      }}
    />
  );
};
